export class UUID {
/**
     * 生成有序 UUID
     */
  static create () {
    let currentTimeMillis = Date.now()

    if (!UUID.lastTime || currentTimeMillis > UUID.lastTime) {
      UUID.lastTime = currentTimeMillis
      UUID.clockSequence = 0
    } else {
      UUID.clockSequence++
    }

    let rand = UUID._cryptoPRNG
    let hex = UUID._hexAligner

    return `${hex((currentTimeMillis / 0x1000) & 0xFFFFFFFF, 8)}-${hex(((currentTimeMillis * 0x10) & 0xFFF0) + (UUID.clockSequence & 0x0F), 4)}-${hex(rand(16), 4)}-${hex(rand(16), 4)}-${hex(rand(48), 12)}`.toUpperCase()
  }

  /**
     * Returns an unsigned x-bit random integer.
     * @private
     * @param {int} x Positive integer ranging from 0 to 53, inclusive.
     * @returns {int} Unsigned x-bit random integer (0 <= f(x) < 2^x).
     */
  static _cryptoPRNG (x) {
    if (x < 0 || x > 53) {
      return NaN
    }

    let crypto = window.crypto || window.msCrypto
    if (crypto && crypto.getRandomValues && typeof Uint32Array !== 'undefined') {
      let ns = crypto.getRandomValues(new Uint32Array(x > 32 ? 2 : 1))
      return x > 32 ? ns[0] + (ns[1] >>> 64 - x) * 0x100000000 : ns[0] >>> 32 - x
    } else {
      let n = 0 | Math.random() * 0x40000000 // 1 << 30
      return x > 30 ? n + (0 | Math.random() * (1 << x - 30)) * 0x40000000 : n >>> 30 - x
    }
  };

  /**
     * Converts an integer to a zero-filled hexadecimal string.
     * @private
     * @param {int} num
     * @param {int} length
     * @returns {string}
     */
  static _hexAligner (num, length) {
    let str = num.toString(16)
    let i = length - str.length
    let z = '0'
    for (; i > 0; i >>>= 1, z += z) {
      if ((i & 1) === 1) {
        str = z + str
      }
    }
    return str
  };
}



// WEBPACK FOOTER //
// ./src/plugins/common.js